import create from 'zustand';
import { CorporateContentQueryState } from './interfaces/CreateQueryState';
import { createCommonCorporateContentQuerySlice } from './slices/CorporateContentQuerySlices/CommonCorporateContentQuerySlice';

export const useCorporateContentQueryStore = create<CorporateContentQueryState>((set) => ({
  ...createCommonCorporateContentQuerySlice(set)
}));
